/** Кнопка языка: под кнопкой звука, на десктопе в правой колонке. Открывает окно выбора. */
import { useStore } from "./hooks";
import { LOCALE_NAMES } from "../i18n";
import { appStore, openWindow } from "./store";
import "./language.css";

export function LanguageButton() {
  const locale = useStore(appStore, (s) => s.locale);
  return (
    <button
      type="button"
      class="language-button"
      data-testid="language-button"
      aria-label={LOCALE_NAMES[locale]}
      title={LOCALE_NAMES[locale]}
      onClick={() => openWindow({ kind: "language" })}
    >
      {locale.toUpperCase()}
    </button>
  );
}
